// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"212":"11c92d2a","275":"28b980b3","392":"465679af","523":"2797aeeb","678":"83aa9529","831":"046d635e","968":"2797aeeb"}[chunkId] + ".chunk.css";
};